export enum AvailableEventResultFilters {
  fio_email = 'fio_email',
}
